import ITexts from "./ITexts";

const en: ITexts = {
  project_documents_alert_message: "Remaining documents will only be visible to logged in users."
};

export default en;
